module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_cp_lp/buyback/mainvisual-bg-pc_622d3a4d46625ae7bdd619076f4d0ca0.png";